import { Dispatch, SetStateAction } from 'react';
import { Pagination, Ticket, TicketById } from '../../interfaces';
import { get, postFormData } from '../../scripts';
import { API } from '../../data/30pay.api';

export const getTickets = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<Ticket> | undefined>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await get<Pagination<Ticket>>(`${API.ticket.mine(page, pageSize)}${query ? query : ''}`).then((response) => {
        setLoading(false);
        setData(response.value.value);
    }).catch((e) => setLoading(false));
};

export const addTicket = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: FormData,
    onComplete: () => void,
) => {
    setLoading(true);
    await postFormData(API.ticket.add, data).then((response) => {
        setLoading(false);
        onComplete();
    }).catch((e) => setLoading(false));
};

export const getTicket = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    ticketId: string,
    setData: Dispatch<SetStateAction<TicketById | undefined>>,
) => {
    setLoading(true);
    await get<TicketById>(API.ticket.get(ticketId)).then((response) => {
        setLoading(false);
        setData(response.value.value);
    }).catch((e) => setLoading(false));
};

export const answerTicket = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: FormData,
    onComplete: () => void,
) => {
    setLoading(true);
    await postFormData(API.ticket.answer, data).then((response) => {
        setLoading(false);
        onComplete();
    }).catch((e) => setLoading(false));
};